module.exports = __webpack_public_path__ + "static/media/img-1.3d1e0fed.jpg";